import { Moon } from "lucide-react";

import {
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/hooks/useTheme";

export function ModeToggleAlt() {
	const { setTheme } = useTheme();

	return (
		<DropdownMenuSub>
			<DropdownMenuSubTrigger>
				<div className="flex gap-2 text-gray-600 dark:text-gray-300">
					<Moon size={16} className="stroke-gray-600 dark:stroke-gray-400" />
					<div className="grid flex-1 text-left text-sm leading-tight">
						Change Theme
					</div>
				</div>
			</DropdownMenuSubTrigger>
			<DropdownMenuSubContent
				className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
			>
				<DropdownMenuGroup>
					<DropdownMenuItem onClick={() => setTheme("light")}>
						Light
					</DropdownMenuItem>
					<DropdownMenuItem onClick={() => setTheme("dark")}>
						Dark
					</DropdownMenuItem>
					<DropdownMenuItem onClick={() => setTheme("system")}>
						System
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuSubContent>
		</DropdownMenuSub>
	);
}
